import { useState } from 'react'
import { View } from 'react-native'
import { useSharedValue, withSpring } from 'react-native-reanimated'
import { useTranslation } from 'react-i18next'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import Checklist from '@ui/elements/Checklist'
import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import MeasurementDetails from './MeasurementDetails'

export default function EyeTest() {
  const { t } = useTranslation(['checklist', 'ui'])
  const text = 'checklist:eyetest'
  const [step, setStepIndex] = useState(0)
  const animatedStep = useSharedValue(0)

  const setStep = (target: number) => {
    setStepIndex(target)
    animatedStep.set(withSpring(target, { overshootClamping: true }))
  }

  const nextButton = () => {
    if (step === 0) return setStep(1)
    if (step === 1) return setStep(2)
    if (step === 2) return setStep(3)
    if (step === 3) return setStep(0)
    return undefined
  }

  // const prevButton = () => {
  //   if (step === 0) return setStep(3)
  //   if (step === 1) return setStep(0)
  //   if (step === 2) return setStep(1)
  //   if (step === 3) return setStep(2)
  //   return undefined
  // }

  return (
    <>
      <Page stage="vision">
        <Header title={t(`${text}.title`)} desc={t(`${text}.desc`)} />
        <View className="gap-8 p-16 pb-32 pt-8">
          <Checklist
            step={step}
            setStep={setStep}
            steps={[
              {
                title: t(`${text}.pd.title`),
                desc: t(`${text}.pd.desc`),
                button: {
                  label: t(step > 0 ? 'ui:repeat' : 'ui:start'),
                  onPress: () => setStep(step > 0 ? 0 : 1),
                },
                nodeChecked: <MeasurementDetails />,
              },
              {
                title: t(`${text}.ticket.title`),
                desc: t(`${text}.ticket.desc`),
                button: {
                  label: t(step > 1 ? 'ui:repeat' : 'ui:ready'),
                  onPress: () => setStep(2),
                },
              },
              {
                title: t(`${text}.room.title`),
                desc: t(`${text}.room.desc`),
                // node: <QueueNumber />,
              },
              {
                title: t(`${text}.examination.title`),
              },
            ]}
          />
        </View>
      </Page>
      <ButtonsFixed
        buttons={[
          {
            variant: 'filled',
            label: t('ui:nextStep'),
            iconEnd: 'arrow-narrow-right',
            onPress: nextButton,
          },
        ]}
      />
    </>
  )
}
